import Matter from 'matter-js';
import { AnimationControls } from 'framer-motion';

import { Dim, Entity } from '../../models';
import {
  posOf,
  getPanelDims,
  getNoteDims,
  getReceptorDims,
  getReceptorY,
} from '../../helpers';
import Receptor from '../renderers/Receptor';
import { INPUT_MODES } from '../../../../../../constants/defaults';

export default (
  windowDims: Dim,
  animates: Record<number, AnimationControls>,
  inputMode = INPUT_MODES.jog,
  y?: number | string,
  xOff = 0
): Entity => {
  const panelDims = getPanelDims(windowDims).gym;
  const noteDims = getNoteDims(windowDims);
  const receptorDims = getReceptorDims(windowDims);
  const receptorY =
    typeof y === 'number'
      ? y
      : getReceptorY(windowDims, receptorDims, y ?? inputMode);
  const landingB = receptorDims.b;
  const dims = { w: windowDims.w, h: receptorDims.h };
  const body = Matter.Bodies.rectangle(
    windowDims.w / 2 + xOff,
    receptorY,
    dims.w,
    dims.h,
    { type: 'receptor' }
  );

  Matter.Body.setStatic(body, true);

  return {
    dims,
    getPos: () => posOf(body),
    body,
    panelDims,
    noteDims,
    landingB,
    animates,
    inputMode,
    renderer: Receptor,
  };
};
